var map = {
	"./arrow-down.svg": 18,
	"./arrow-grey.svg": 19,
	"./arrow-white-up.svg": 20,
	"./black-arrow.svg": 21,
	"./blue-check.svg": 22,
	"./boost-icon.svg": 23,
	"./check.svg": 24,
	"./clean-map-big.svg": 25,
	"./clean-map-small.svg": 26,
	"./green-sale.svg": 27,
	"./grey-check.svg": 28,
	"./groups.svg": 29,
	"./price.svg": 30,
	"./production-icon.svg": 31,
	"./question.svg": 32,
	"./redaction.svg": 33,
	"./rocket.svg": 34,
	"./sale.svg": 35,
	"./success.svg": 36,
	"./unchecked.svg": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;